import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, Tooltip } from '@material-ui/core'
import classnames from 'classnames'
import gameDrawerTabsStyles from './gameDrawerTabs.styles'

const useStyles = makeStyles(gameDrawerTabsStyles)

const GameDrawerTabs = ({ active, onChange, tabs }) => {
  const classes = useStyles()

  return (
    <div className={classes.root} role='tablist'>
      {tabs.map(({ key, label, showDot, error, disabled, disabledHint }) => {
        const isActive = key === active
        const button = (
          <button
            type='button'
            role='tab'
            aria-selected={isActive}
            disabled={disabled}
            className={classnames(classes.tab, {
              [classes.tabActive]: isActive,
              [classes.tabDisabled]: disabled,
            })}
            onClick={() => !disabled && onChange(key)}
          >
            {label}
            {/* Reserve the dot's space on dot-capable tabs (showDot defined) or tabs that can
                surface an error, so toggling the dot's visibility never shifts sibling tabs.
                An error takes visual precedence (red) over the coral active-content dot. */}
            {(showDot !== undefined || error !== undefined) && (
              <span
                className={classnames(classes.dot, {
                  [classes.dotError]: error,
                  [classes.dotHidden]: !error && !showDot,
                })}
              />
            )}
            <span
              className={classnames(classes.underline, {
                [classes.underlineActive]: isActive,
              })}
            />
          </button>
        )

        // A disabled <button> swallows hover events, so wrap it in a span for the Tooltip
        // to explain why the tab is unavailable (e.g. no streaming-capable court selected).
        if (disabled && disabledHint) {
          return (
            <Tooltip key={key} title={disabledHint}>
              <span className={classes.tooltipWrap}>{button}</span>
            </Tooltip>
          )
        }
        return <React.Fragment key={key}>{button}</React.Fragment>
      })}
    </div>
  )
}

GameDrawerTabs.propTypes = {
  active: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      showDot: PropTypes.bool,
      error: PropTypes.bool,
      disabled: PropTypes.bool,
      disabledHint: PropTypes.string,
    }),
  ).isRequired,
}

export default GameDrawerTabs
